module.exports = __webpack_public_path__ + "static/media/vid1.9088bb03.mp4";